import { IconText } from '@/shared/ui/icon-text'

import type { FC, ReactNode } from 'react'

export type BlockHeaderSectionContentProps = {
  children: ReactNode
}

/**
 * Block.TitleSectionContent - Styled section title with h5-medium uppercase typography
 *
 * Uses IconText with predefined parameters for section titles.
 * Allows having an icon and uppercase text with base-content-50 color.
 * @example In a Block.Title
 * <Block.Title>
 *   <Block.TitleSectionContent>
 *     <People />
 *     Section title
 *   </Block.TitleSectionContent>
 * </Block.Title>
 */
export const TypographySection: FC<BlockHeaderSectionContentProps> = ({ children }) => {
  return (
    <IconText type="heading" variant="h5-medium" color="base-content-50" uppercase>
      {children}
    </IconText>
  )
}

TypographySection.displayName = 'TypographySection'
